import { AppBundle } from 'api/optimalprint-sdk.d';

export const gtmOthersAlsoBoughtEvent = (
  currentProductId: number,
  categoryName: string,
  clickedProduct: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Family.IDesign,
) => ({
  event: 'othersAlsoBoughtRecommendation',
  currentProductId,
  clickedProductId: clickedProduct.productId,
  categoryName,
});

export default gtmOthersAlsoBoughtEvent;
